import { Socket } from 'socket.io-client';

/**
 * Socket Service (DISABLED)
 * WebSocket and HTTP polling are completely disabled in favor of Firebase Cloud Messaging (FCM).
 */
export const socketService = {
	getSocket(): Socket | null {
		return null;
	},

	isConnected(): boolean {
		return false;
	},

	subscribeStatus(callback: (connected: boolean) => void): () => void {
		callback(false);
		return () => {};
	},

	connect(_customToken?: string): Socket | null {
		// Sockets & polling completely disabled
		return null;
	},

	disconnect(): void {
		// No-op
	},

	on(_event: string, _callback: (...args: any[]) => void): void {
		// No-op
	},

	off(_event: string, _callback?: (...args: any[]) => void): void {
		// No-op
	},

	emit(_event: string, ..._args: any[]): void {
		// No-op
	},
};

export default socketService;
